import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import { Button } from './ui/Button';
export function Footer() {
  return <footer className="bg-[#263238] text-gray-300 pt-16 pb-8" data-id="element-78">
      <div className="container mx-auto px-4" data-id="element-79">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12" data-id="element-80">
          {/* Brand Column */}
          <div data-id="element-81">
            <img src="https://cdn.magicpatterns.com/uploads/bitF4Fp2Mn5F2xN1PkGCY5/locanto_color.svg" alt="Locanto" className="h-8 mb-6 brightness-0 invert" data-id="element-82" />
            <p className="mb-6 text-gray-400 text-sm leading-relaxed" data-id="element-83">
              Your free local classifieds site. Find what you need, sell what
              you don't, and connect with your community in Singapore.
            </p>
            <div className="flex gap-4" data-id="element-84">
              <a href="#" className="hover:text-white transition-colors" data-id="element-85">
                <Facebook className="h-5 w-5" data-id="element-86" />
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-87">
                <Twitter className="h-5 w-5" data-id="element-88" />
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-89">
                <Instagram className="h-5 w-5" data-id="element-90" />
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-91">
                <Linkedin className="h-5 w-5" data-id="element-92" />
              </a>
            </div>
          </div>

          {/* Categories */}
          <div data-id="element-93">
            <h4 className="text-white font-semibold mb-6" data-id="element-94">Categories</h4>
            <ul className="space-y-3 text-sm" data-id="element-95">
              <li data-id="element-96">
                <a href="#" className="hover:text-[#00897B] transition-colors" data-id="element-97">
                  Jobs in Singapore
                </a>
              </li>
              <li data-id="element-98">
                <a href="#" className="hover:text-[#00897B] transition-colors" data-id="element-99">
                  Real Estate
                </a>
              </li>
              <li data-id="element-100">
                <a href="#" className="hover:text-[#00897B] transition-colors" data-id="element-101">
                  Buy & Sell
                </a>
              </li>
              <li data-id="element-102">
                <a href="#" className="hover:text-[#00897B] transition-colors" data-id="element-103">
                  Services
                </a>
              </li>
              <li data-id="element-104">
                <a href="#" className="hover:text-[#00897B] transition-colors" data-id="element-105">
                  Community
                </a>
              </li>
              <li data-id="element-106">
                <a href="#" className="hover:text-[#00897B] transition-colors" data-id="element-107">
                  Events
                </a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div data-id="element-108">
            <h4 className="text-white font-semibold mb-6" data-id="element-109">Support</h4>
            <ul className="space-y-3 text-sm" data-id="element-110">
              <li data-id="element-111">
                <a href="#" className="hover:text-[#00897B] transition-colors" data-id="element-112">
                  Help & FAQ
                </a>
              </li>
              <li data-id="element-113">
                <a href="#" className="hover:text-[#00897B] transition-colors" data-id="element-114">
                  Safety Tips
                </a>
              </li>
              <li data-id="element-115">
                <a href="#" className="hover:text-[#00897B] transition-colors" data-id="element-116">
                  Contact Us
                </a>
              </li>
              <li data-id="element-117">
                <a href="#" className="hover:text-[#00897B] transition-colors" data-id="element-118">
                  Terms of Use
                </a>
              </li>
              <li data-id="element-119">
                <a href="#" className="hover:text-[#00897B] transition-colors" data-id="element-120">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Partner Sites */}
          <div data-id="element-121">
            <h4 className="text-white font-semibold mb-6" data-id="element-122">Partner Sites</h4>
            <ul className="space-y-2 text-sm" data-id="element-123">
              <li data-id="element-124">
                <a href="https://ttvip-64.com/" target="_blank" rel="noopener noreferrer" className="hover:text-[#00897B] transition-colors" data-id="element-125">
                  ttvip-64.com
                </a>
              </li>
              <li data-id="element-126">
                <a href="https://shiok27.com/" target="_blank" rel="noopener noreferrer" className="hover:text-[#00897B] transition-colors" data-id="element-127">
                  shiok27.com
                </a>
              </li>
              <li data-id="element-128">
                <a href="https://xfy01.net/" target="_blank" rel="noopener noreferrer" className="hover:text-[#00897B] transition-colors" data-id="element-129">
                  xfy01.net
                </a>
              </li>
              <li data-id="element-130">
                <a href="https://sgharem6.net/" target="_blank" rel="noopener noreferrer" className="hover:text-[#00897B] transition-colors" data-id="element-131">
                  sgharem6.net
                </a>
              </li>
              <li data-id="element-132">
                <a href="https://qc52.me/" target="_blank" rel="noopener noreferrer" className="hover:text-[#00897B] transition-colors" data-id="element-133">
                  qc52.me
                </a>
              </li>
              <li data-id="element-134">
                <a href="https://sglonelyguy.me/" target="_blank" rel="noopener noreferrer" className="hover:text-[#00897B] transition-colors" data-id="element-135">
                  sglonelyguy.me
                </a>
              </li>
              <li data-id="element-136">
                <a href="https://ttvip.life/" target="_blank" rel="noopener noreferrer" className="hover:text-[#00897B] transition-colors" data-id="element-137">
                  ttvip.life
                </a>
              </li>
              <li data-id="element-138">
                <a href="https://locanto.space/" target="_blank" rel="noopener noreferrer" className="hover:text-[#00897B] transition-colors" data-id="element-139">
                  locanto.space
                </a>
              </li>
              <li data-id="element-140">
                <a href="https://kkbaby.site/" target="_blank" rel="noopener noreferrer" className="hover:text-[#00897B] transition-colors" data-id="element-141">
                  kkbaby.site
                </a>
              </li>
              <li data-id="element-142">
                <a href="https://xfy8.com/" target="_blank" rel="noopener noreferrer" className="hover:text-[#00897B] transition-colors" data-id="element-143">
                  xfy8.com
                </a>
              </li>
              <li data-id="element-144">
                <a href="https://sgbeautycastle.live/" target="_blank" rel="noopener noreferrer" className="hover:text-[#00897B] transition-colors" data-id="element-145">
                  sgbeautycastle.live
                </a>
              </li>
              <li data-id="element-146">
                <a href="https://shiok26.site/" target="_blank" rel="noopener noreferrer" className="hover:text-[#00897B] transition-colors" data-id="element-147">
                  shiok26.site
                </a>
              </li>
              <li data-id="element-148">
                <a href="https://sgharem.site/" target="_blank" rel="noopener noreferrer" className="hover:text-[#00897B] transition-colors" data-id="element-149">
                  sgharem.site
                </a>
              </li>
              <li data-id="element-150">
                <a href="https://shiok8.xyz/" target="_blank" rel="noopener noreferrer" className="hover:text-[#00897B] transition-colors" data-id="element-151">
                  shiok8.xyz
                </a>
              </li>
              <li data-id="element-152">
                <a href="https://geylang777.info/" target="_blank" rel="noopener noreferrer" className="hover:text-[#00897B] transition-colors" data-id="element-153">
                  geylang777.info
                </a>
              </li>
              <li data-id="element-154">
                <a href="https://ttvip-62.site/" target="_blank" rel="noopener noreferrer" className="hover:text-[#00897B] transition-colors" data-id="element-155">
                  ttvip-62.site
                </a>
              </li>
              <li data-id="element-156">
                <a href="https://geylang666.me/" target="_blank" rel="noopener noreferrer" className="hover:text-[#00897B] transition-colors" data-id="element-157">
                  geylang666.me
                </a>
              </li>
              <li data-id="element-158">
                <a href="https://isyou.net/" target="_blank" rel="noopener noreferrer" className="hover:text-[#00897B] transition-colors" data-id="element-159">
                  isyou.net
                </a>
              </li>
            </ul>
          </div>

          {/* CTA Column */}
          <div data-id="element-160">
            <h4 className="text-white font-semibold mb-6" data-id="element-161">Start Posting</h4>
            <p className="text-sm text-gray-400 mb-6" data-id="element-162">
              Do you have something to sell? Post your ad on Locanto for free!
            </p>
            <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" data-id="element-163">
              <Button variant="orange" className="w-full font-bold" data-id="element-164">
                Post Free Ad
              </Button>
            </a>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-500" data-id="element-165">
          <p data-id="element-166">
            &copy; {new Date().getFullYear()} Locanto Singapore. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-167">
            <a href="#" className="hover:text-white" data-id="element-168">
              Mobile Site
            </a>
            <a href="#" className="hover:text-white" data-id="element-169">
              About Locanto
            </a>
            <a href="#" className="hover:text-white" data-id="element-170">
              Sitemap
            </a>
          </div>
        </div>
      </div>
    </footer>;
}